module.exports = __webpack_public_path__ + "static/img/learning.5e3993b.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/index/assets/img/event/learning.png
// module id = taj8
// module chunks = 32